import {
  ComputerAidedLearningLinks,
  EducationLeftMenuList,
} from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const Urgent_Notice = () => (
  <TableStructure
    title="Urgent Notice"
    heading={"List of Notices"}
    list={ComputerAidedLearningLinks}
    columnNo={1}
    leftMenuList={EducationLeftMenuList}
    longMenuList={false}
  />
);

export default Urgent_Notice;
